import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { composeProviders } from './composeProviders.js';
import { SearchProvider } from '../hooks/SearchContext.tsx';
import { AuthProvider } from '../hooks/AuthContext.tsx';
import { ThemeProvider } from '../hooks/ThemeContext.tsx';
import { HistoryProvider } from '../hooks/HistoryContext.tsx';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    },
});

export const AppProviders = composeProviders(
    ({ children }) => <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>,
    AuthProvider,
    HistoryProvider,
    SearchProvider,
    ThemeProvider,
);